import {BaseErrorSchema, Error} from '@innovactions/frontend-library';

export class ErrorSchema extends BaseErrorSchema {

  override get errors(): Error[] {
    return [
      new Error('required', 'Dit veld is verplicht.', 'text-red-500'),
      new Error('email', 'Dit is geen geldig e-mailadres.', 'text-red-500'),
      new Error('phone', 'Dit is geen geldig telefoonnummer.', 'text-red-500'),
      new Error('coc', "Dit is geen geldig kvk nummer", "text-red-500"),
      new Error("vat", "Dit is geen geldig btw nummer", "text-red-500"),
      new Error('min', 'Deze waarde is te laag.', 'text-red-500'),
      new Error('max', 'Deze waarde is te hoog.', 'text-red-500'),
      new Error('minTime', 'Dit tijdstip valt niet binnen een werkdag.', 'text-red-500'),
      new Error('maxTime', 'Dit tijdstip valt niet binnen een werkdag.', 'text-red-500'),
      new Error('maxlength', '', ''),
    ];
  }
}
